import { h, Component } from 'preact';
import MenuObject from '../canvas/menu-object';
import store from '../store';
import util from '../util';
import { unescapeHtml } from '../canvas/menu-object';
import { syncInGroup } from "../canvas/menu-group";
import FormattableField from './FormattableField';

export default class MenuObjectEditNameNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curName: '',
      curNotes: '',
      isEditMode: true,
      showGroupNotesToolbar: false,
      showGroupNotesSpecialChars: false,
    };

    this.updateItemValue = this.updateItemValue.bind(this);
    this.updateName = this.updateName.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
  }

  updateItemValue(key, value) {
    if (key === 'group-name') {
      this.updateName(value);
    } else if (key === 'group-notes') {
      this.updateNotes(value);
    }
  }

  updateName(name) {
    this.setState({ curName: name });
    MenuObject.updateMOName(this.props.$element, name);
    MenuObject.fixLineHeights(this.props.$element, true);
    syncInGroup(this.props.$element, store.getState().menuGroups);
  }

  updateNotes(notes) {
    this.setState({ curNotes: notes });
    MenuObject.updateMONotes(this.props.$element, notes);
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  componentDidMount() {
    let foundName = this.props.$element.find('.wrapper .mo-name')?.html();
    if (foundName) {
      foundName = unescapeHtml(foundName);
      foundName = foundName.trim();
      this.setState({ curName: foundName });
    }

    let foundNotes = this.props.$element.find('.wrapper .mo-notes')?.html();
    if (foundNotes) {
      foundNotes = unescapeHtml(foundNotes);
      foundNotes = foundNotes.trim();
      this.setState({ curNotes: foundNotes });
    }

    util.nextTick(() => {
      if (window.localStorage.getItem("mo-mode") !== "notes") {
        $('#groupNameEditor')[0]?.focus();
      }
      window.localStorage.removeItem("mo-mode");
    }, 100);
  }

  componentWillUnmount() {
    if (this.state.curName === '') {
      this.deleteName();
    }
    if (this.state.curNotes === '') {
      this.deleteNotes();
    }
    if (this.props.$element) MenuObject.fixLineHeights(this.props.$element, true);
  }

  onNameFocus() {
    const $element = this.props.$element;
    if (!$element) return;

    const $name = $element.find('.mo-name');
    const $notes = $element.find('.mo-notes');
    if ($name) {
      $name.addClass('selected');
    }
    if ($notes) {
      $notes.removeClass('selected');
    }
  }

  onNotesFocus() {
    const $element = this.props.$element;
    if (!$element) return;

    const $name = $element.find('.mo-name');
    const $notes = $element.find('.mo-notes');
    if ($name) {
      $name.removeClass('selected');
    }
    if ($notes) {
      $notes.addClass('selected');
    }
  }

  deleteName() {
    this.props.$element.find('.wrapper .mo-name').remove();
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  deleteNotes() {
    this.props.$element.find('.wrapper .mo-notes').remove();
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  render(props, state) {
    if (store.getState().isMobileVersion && props.activeIdx !== state.activeIdx) {
      this.setState({ active: props.active, activeIcons: props.active.icons, activeIdx: props.activeIdx })
    }

    return (
      <div className="no-drag modal-content">
        <div className="modal-content-edit">
          <div className="item-details scroller">
            <div>
              <FormattableField
                typeClass={'group-name'}
                typeId={'groupName'}
                curFieldText={state.curName}
                contentEditMode={props.contentEditMode}
                tabIndex={1}
                updateItemValue={this.updateItemValue}
                $element={props.$element}
              />

              <FormattableField
                typeClass={'group-notes'}
                typeId={'groupNotes'}
                curFieldText={state.curNotes}
                contentEditMode={props.contentEditMode}
                tabIndex={2}
                updateItemValue={this.updateItemValue}
                $element={props.$element}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
